module.exports = __webpack_public_path__ + "static/media/southern_sea_otter.817991cb.jpg";